const defaultThankYouItems = [
  'section_first',
  'section_second',
];

const ocmThankYouItems = [
  'section_first.ocm',
  'section_second.ocm',
  'section_third.ocm',
  'section_fourth.ocm',
  'section_fifth.ocm',
];

const thankYouItemsAutoApprovalFounds = [
  'section_first.auto_approval_funds',
  'section_third.auto_approval_funds',
  'section_fourth.auto_approval_funds',
  'section_fifth.auto_approval_funds',
];

const thankYouItemsAutoApprovalNoFounds = [
  'section_first.auto_approval_no_funds',
  'section_fourth.auto_approval_no_funds',
  'section_fifth.auto_approval_no_funds',
];

const thankYouItemsUpgrade = [
  'section_first_upgrade',
  'section_second_upgrade',
];

const thankYouItemsUpsell = [
  'section_first_upsell',
  'section_second_upsell',
];

function getThankYouItems({
  isOcm, isApproved, isCreditLine, hasFunds,
}) {
  const isCreditLineWithoutFunds = !hasFunds && isCreditLine;

  if (INCREASE_APP) {
    return isCreditLine ? thankYouItemsUpgrade : thankYouItemsUpsell;
  }
  if (isOcm) return ocmThankYouItems;
  if (isApproved) {
    if (isCreditLineWithoutFunds) return thankYouItemsAutoApprovalNoFounds;
    if (hasFunds) return thankYouItemsAutoApprovalFounds;
  }
  return defaultThankYouItems;
}

function getThankYouText({
  isOcm, isCreditLine, emailPending,
}) {
  if (emailPending) return 'offer.submit.thankyoutext_email_not_confirmed';
  if (INCREASE_APP) {
    return isCreditLine ? 'offer.submit.thankyoutext.upgrade' : 'offer.submit.thankyoutext.upsell';
  }
  return isOcm ? 'offer.submit.thankyoutext' : 'offer.submit.thank_you_message';
}

export const useThankYouContent = ({
  isOcm, isApproved, isCreditLine, hasFunds, emailPending,
}) => {
  const thankYouItems = getThankYouItems({
    isOcm, isApproved, isCreditLine, hasFunds,
  });

  const thankYouText = getThankYouText({ isOcm, isCreditLine, emailPending });

  return { thankYouItems, thankYouText };
};
